module.exports = __webpack_public_path__ + "static/img/compass_rose.ad60c169.svg";